import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Grid, Typography, Tooltip } from '@mui/material'
import { useStyles } from '../CaseDiagnosisStyles'
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded'
import SummarizeIcon from '@mui/icons-material/Summarize'
import VisibilityIcon from '@mui/icons-material/Visibility'
import { getBarcodeData, getSummaryTreeData } from '../../../actions'
import { RootState } from '../../../reducers'
import GrossDescription from './GrossDescription'

export default function SlidesInformation({
  trfBarcode,
  handleViewerOpen,
  handleReportOpen,
  isReadOnlyMode,
}): JSX.Element | null {
  const classes = useStyles()
  const dispatch = useDispatch()
  const sampleData = useSelector((state: RootState) => state.addSampleLocationData)
  const { role, multiple_classifiers_allowed } = useSelector((state: RootState) => state.userLogin)
  const { procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const sampleTreeData = sampleData.payload
  const [messages, setMessages] = useState({} as any)
  const [isLocation, setLocations] = useState(true)
  const getClassName = (type, isDiagnosed) =>
    type === 'disabled'
      ? `${classes.disabledStainName} `
      : isDiagnosed && isDiagnosed === true
      ? `${classes.diagnosedStainName}`
      : `${classes.notDiagnosedStainName}`
  const getReportClassName = (isCancelled) =>
    role !== 'NL_WOMA_ADMIN' && (isReadOnlyMode || isCancelled)
      ? `${classes.disabledReportLink} `
      : `${classes.viewReport}`
  const checkInactiveReason = (sample) => {
    if (sample.children && sample.children.length) {
      const validChildren = [] as any
      sample.children.map((child) => {
        if (!child.inactiveReason) {
          validChildren.push(child)
        }
      })
      if (validChildren.length) {
        return false
      }
    }
    return true
  }
  const locations =
    sampleData?.payload &&
    sampleData?.payload.length > 0 &&
    sampleData?.payload.map((obj) => {
      return obj.location
    })
  const getIconClassName = (isCancelled) =>
    role !== 'NL_WOMA_ADMIN' && (isReadOnlyMode || isCancelled)
      ? `${classes.disabledReportIcon} `
      : `${classes.reportIcon}`
  const getVisibilityIconClassName = (type) =>
    type === 'disabled' ? classes.disabledDiagnosedIcon : classes.notDiagnosedIcon
  const handleSlideClick = async (slide, stain, location, trfBarcode) => {
    if (location) {
      const currentSelection = location
      const currentLocationData = sampleData['payload'].filter((item) => item.location === currentSelection)
      const currentLocation = currentLocationData[0]
      const stains: any[] = []
      if (currentLocation && currentLocation.children && currentLocation.children.length > 0) {
        currentLocation.children.map((slide) => {
          if (
            slide.type === 'expandable' &&
            slide.children &&
            slide.children.length > 0 &&
            slide.children[0].type === 'expandable' &&
            slide.children[0].children.length > 0
          ) {
            slide.children[0].children?.map((subChild, index1) => {
              const name =
                subChild.sampleBarcode +
                ' ' +
                (subChild.sampleStain ? subChild.sampleStain : subChild.children[0].sampleStain)
              const type = subChild.type
              const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
              const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
              stains.push({
                name: name,
                type: type,
                isDiagnosed: isDiagnosed,
                isDontReport: isDontReport,
              })
            })
          } else if (slide.type === 'expandable' && slide.children && slide.children.length > 0) {
            slide.children?.map((subChild, index2) => {
              const name = subChild.sampleBarcode + ' ' + subChild.sampleStain
              const type = subChild.type
              const isDiagnosed = subChild.isDiagnosed === null ? false : subChild.isDiagnosed
              const isDontReport = subChild.isDontReport === null ? false : subChild.isDontReport
              stains.push({
                name: name,
                type: type,
                isDiagnosed: isDiagnosed,
                isDontReport: isDontReport,
              })
            })
          } else if (slide.type === 'checkbox') {
            const name = slide.sampleBarcode + ' ' + slide.sampleStain
            const type = slide.type
            const isDiagnosed = slide.isDiagnosed === null ? false : slide.isDiagnosed
            const isDontReport = slide.isDontReport === null ? false : slide.isDontReport
            stains.push({
              name: name,
              type: type,
              isDiagnosed: isDiagnosed,
              isDontReport: isDontReport,
            })
          }
        })
        await dispatch(
          getSummaryTreeData({
            trfBarcode: trfBarcode,
            location: location,
            procedureCode: procedureCodeId,
          }),
        )
        await dispatch(
          getBarcodeData({
            trfBarcode: trfBarcode,
            slide: slide,
            multiple_classifiers_allowed: multiple_classifiers_allowed,
          }),
        )
        handleViewerOpen({
          slide: slide,
          stain: stain,
          location: location,
          trfBarcode: trfBarcode,
          stainData: stains,
          isShow: false,
        })
      }
    }
  }
  const handleReportPreview = async (location) => {
    handleReportOpen({ location: location })
  }

  useEffect(() => {
    if (isLocation && locations && locations.length > 0) {
      setLocations(false)
    }
  }, [locations])

  useEffect(() => {
    if (sampleTreeData && sampleTreeData.length > 0) {
      const locationGrossDescriptions = {} as any
      sampleTreeData.map((sample, index) => {
        const label1 = sample.label + '1'
        const label2 = sample.label + '2'
        const location = sample.location
        const grossDescriptionArray = [] as any
        for (let k = 0; k < sample.children.length; k++) {
          if (sample.children[k].label === label1) {
            grossDescriptionArray.push({
              label: sample.children[k].label,
              value: sample.children[k].smpGrossDescription,
            })
          } else if (sample.children[k].label === label2) {
            grossDescriptionArray.push({
              label: sample.children[k].label,
              value: sample.children[k].smpGrossDescription,
            })
          }
        }
        locationGrossDescriptions[location] = grossDescriptionArray
      })
      setMessages(locationGrossDescriptions)
    }
  }, [sampleTreeData])
  return (
    <>
      <Box
        style={{
          boxSizing: 'border-box',
          boxShadow: '3px 0px 6px 0px rgba(0, 0, 0, 0.13)',
          marginBottom: '10px',
          backgroundColor: '#fff',
          height: '98%',
        }}
      >
        <div className={classes.sampleLocations}>
          <div className={classes.sampleLocationsTitle}>Sample Locations</div>
          {sampleTreeData &&
            sampleTreeData.length > 0 &&
            sampleTreeData.map((sample, index) => {
              return (
                <Box
                  key={index}
                  className={classes.slideItem}
                  sx={{
                    '& .MuiGrid-item': {
                      padding: '0px !important',
                      marginBottom: '10px',
                    },
                  }}
                >
                  <div className={classes.location}>
                    <fieldset style={{ borderStyle: 'solid', borderRadius: '5px' }}>
                      <legend style={{ width: '98%' }}>
                        <Typography className={classes.locationTitle}> {sample.location} </Typography>
                        {messages && messages[sample.location] && (
                          <GrossDescription messages={messages[sample.location]} />
                        )}
                        <div
                          className={getReportClassName(checkInactiveReason(sample))}
                          onClick={() => handleReportPreview(sample.location)}
                        >
                          <SummarizeIcon className={getIconClassName(checkInactiveReason(sample))} />
                          Report
                        </div>
                      </legend>
                      {sample &&
                        sample.children &&
                        sample.children.length > 0 &&
                        sample.children.map((slide, slideIndex) => {
                          return (
                            <fieldset
                              style={{
                                borderStyle: 'solid',
                                borderRadius: '5px',
                              }}
                              key={slideIndex}
                            >
                              <legend>
                                {slide.collectionPlace} {' ('}
                                {slide.sampleBarcode}
                                {slide.children
                                  ? slide.children.length > 0
                                    ? slide?.children[0]
                                      ? '/' + slide?.children[0].sampleBarcode
                                      : ''
                                    : slide.sampleBarcode
                                  : ''}
                                {')'}
                              </legend>
                              <Grid
                                container
                                spacing={{ xs: 2, md: 3 }}
                                columns={{ xs: 4, sm: 8, md: 12 }}
                                className={classes.slideGrid}
                              >
                                {slide.type === 'expandable' &&
                                  slide.children &&
                                  slide.children.length > 0 &&
                                  slide.children[0].type === 'expandable' &&
                                  slide.children[0].children.length > 0 &&
                                  slide.children[0].children?.map((subChild, index1) => {
                                    return (
                                      <>
                                        <Grid item xs={2} sm={4} md={4} key={index1}>
                                          <div
                                            className={getClassName(subChild.type, subChild.isDiagnosed)}
                                            onClick={() =>
                                              handleSlideClick(
                                                subChild.sampleBarcode,
                                                subChild.sampleStain
                                                  ? subChild.sampleStain
                                                  : subChild.children[0].sampleStain,
                                                sample.location,
                                                trfBarcode,
                                              )
                                            }
                                          >
                                            {subChild.isDiagnosed === null && (
                                              <Tooltip title="Not diagnosed" placement="top-start">
                                                <VisibilityIcon className={getVisibilityIconClassName(subChild.type)} />
                                              </Tooltip>
                                            )}
                                            {subChild.isDontReport && subChild.isDiagnosed && (
                                              <Tooltip title="Do not report" placement="top-start">
                                                <CancelRoundedIcon className={classes.excludeIcon} />
                                              </Tooltip>
                                            )}
                                            {!subChild.isDontReport && subChild.isDiagnosed && (
                                              <Tooltip title="Diagnosed" placement="top-start">
                                                <CheckCircleRoundedIcon className={classes.includeIcon} />
                                              </Tooltip>
                                            )}
                                            <span>
                                              {subChild.sampleStain
                                                ? subChild.sampleStain
                                                : subChild.children[0].sampleStain}
                                            </span>
                                          </div>
                                          <div style={{ marginLeft: '25%' }}>{subChild.sampleBarcode}</div>
                                        </Grid>
                                      </>
                                    )
                                  })}
                                {slide.type === 'expandable' &&
                                  slide.children &&
                                  slide.children.length > 0 &&
                                  slide.children?.map((subChild, index2) => {
                                    return (
                                      subChild.type !== 'expandable' && (
                                        <>
                                          <Grid item xs={2} sm={4} md={4} key={index2}>
                                            <div
                                              className={getClassName(subChild.type, subChild.isDiagnosed)}
                                              onClick={() =>
                                                handleSlideClick(
                                                  subChild.sampleBarcode,
                                                  subChild.sampleStain,
                                                  sample.location,
                                                  trfBarcode,
                                                )
                                              }
                                            >
                                              {!subChild.isDiagnosed && (
                                                <Tooltip title="Not diagnosed" placement="top-start">
                                                  <VisibilityIcon
                                                    className={getVisibilityIconClassName(subChild.type)}
                                                  />
                                                </Tooltip>
                                              )}
                                              {subChild.isDontReport && subChild.isDiagnosed && (
                                                <Tooltip title="Do not report" placement="top-start">
                                                  <CancelRoundedIcon className={classes.excludeIcon} />
                                                </Tooltip>
                                              )}
                                              {!subChild.isDontReport && subChild.isDiagnosed && (
                                                <Tooltip title="Diagnosed" placement="top-start">
                                                  <CheckCircleRoundedIcon className={classes.includeIcon} />
                                                </Tooltip>
                                              )}
                                              <span>{subChild.sampleStain}</span>
                                            </div>
                                            <div style={{ marginLeft: '25%' }}>{subChild.sampleBarcode}</div>
                                          </Grid>
                                        </>
                                      )
                                    )
                                  })}
                                {slide.type !== 'expandable' && (
                                  <Grid item xs={2} sm={4} md={4}>
                                    <div
                                      className={getClassName(slide.type, slide.isDiagnosed)}
                                      onClick={() =>
                                        handleSlideClick(
                                          slide.sampleBarcode,
                                          slide.sampleStain,
                                          sample.location,
                                          trfBarcode,
                                        )
                                      }
                                    >
                                      {slide.isDiagnosed === null && (
                                        <Tooltip title="Not diagnosed" placement="top-start">
                                          <VisibilityIcon className={getVisibilityIconClassName(slide.type)} />
                                        </Tooltip>
                                      )}
                                      {slide.isDontReport && slide.isDiagnosed && (
                                        <Tooltip title="Do not report" placement="top-start">
                                          <CancelRoundedIcon className={classes.excludeIcon} />
                                        </Tooltip>
                                      )}
                                      {!slide.isDontReport && slide.isDiagnosed && (
                                        <Tooltip title="Diagnosed" placement="top-start">
                                          <CheckCircleRoundedIcon className={classes.includeIcon} />
                                        </Tooltip>
                                      )}
                                      <span>{slide.sampleStain}</span>
                                    </div>
                                    <div style={{ marginLeft: '25%' }}>{slide.sampleBarcode}</div>
                                  </Grid>
                                )}
                              </Grid>
                            </fieldset>
                          )
                        })}
                    </fieldset>
                  </div>
                </Box>
              )
            })}
        </div>
      </Box>
    </>
  )
}
